import { later } from '@ember/runloop';
import EmberService from '@ember/service';
import { tracked } from '@glimmer/tracking';

import moment from 'moment';

export default class TimerService extends EmberService {
	@tracked ticker = 0; // changed every minute to refresh relative times
	@tracked currentTs = 0; // "current" unix timestamp (updated every minute)

	observe(): void {
		// shortcut method to add ticker to autotracking list
		// eslint-disable-next-line @typescript-eslint/no-unused-expressions
		this.ticker;
	}

	increaseTicker(): void {
		this.ticker++;
		this.currentTs = Math.floor(moment.utc().valueOf() / 1000);
		later(this, this.increaseTicker, 60 * 1000);
	}
}

declare module '@ember/service' {
	interface Registry {
		timer: TimerService;
	}
}
